/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_NavInputs */

const vi_cdo_nav = /** @type {(inputs: Cdo_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn giao hợp đồng`)
};

/**

* @param {Cdo_NavInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_nav = /** @type {((inputs?: Cdo_NavInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_NavInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_nav(inputs)
});